/*eslint no-unused-vars: 0*/
import { app, db, functions, ui, storage, analytics, auth } from "./Firebase";

export type AppHandler<S = any, E = any, Props=any> = (controller: AppController<S, E, Props>, params?: any) => any;

export default class AppController<S, E, Props> {
  getState: () => S;
  setState: <K extends keyof S>(
            state: ((prevState: Readonly<S>, props: Readonly<Props>) => Pick<S, K> | S | null) | (Pick<S, K> | S | null),
            callback?: () => void,
        ) => void
  window: any;
  app = app
  auth =  auth 
  user: any;
  db = db
  analytics= analytics
  functions = functions
  storage = storage
  ui = ui 

  PROTOTYPE: boolean = true;

  constructor(getState: () => S, setState:  <K extends keyof S>(
            state: ((prevState: Readonly<S>, props: Readonly<Props>) => Pick<S, K> | S | null) | (Pick<S, K> | S | null),
            callback?: () => void,
        ) => void, window: any) {
    this.getState = getState;
    this.setState = setState;
    this.window = window;
    console.log("Appcontroller Firebase init !! ");
    //  console.log('Appcontroller auth: ', auth);
    //  console.log('Appcontroller analytics: ', analytics);
    //  console.log('Appcontroller storage: ', storage);
    //  console.log('Appcontroller ui: ', ui);
    //  console.log('Appcontroller functions: ', functions);
    //  console.log('Appcontroller db: ', db);
    //  console.log('Appcontroller app: ', app);
  }


  handleEvent: (e: E) => any = async (e: E) => {
    // TO IMPLEMENT
  };
}
